import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {File02Icon, PlusIcon, SquareIcon} from '@/components/ui/icon/Icon'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {StyledPatientDetailsCtaButtonLink} from '@/features/patients/components/patient-details-options-cta/style'
import {projectStatusToColor, projectStatusToLabel} from '@/features/projects/utils'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {generatePath} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'

export const TreatmentRequestOptionsCta = ({
    patientId,
    project,
    hasAuthorizedDate
}: {
    patientId: string
    project?: TreatmentRequestExtended['project']
    hasAuthorizedDate?: boolean
}) => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    if (permissions?.projects?.write && !project) {
        return (
            <Tooltip
                variant="light"
                content={t('treatment_requests:missing_authorization_date')}
                triggerProps={{asChild: true}}
            >
                <ButtonLink
                    disabled={!hasAuthorizedDate}
                    to={{
                        pathname: routes.CREATE_PROJECT.handle.path,
                        search: `?patientId=${patientId}&origin=treatment_request`
                    }}
                    variant="primaryNeutral"
                >
                    <PlusIcon />
                    {t('commons:rehabilitation_project', {count: 1})}
                </ButtonLink>
            </Tooltip>
        )
    }

    if (project) {
        return (
            <StyledPatientDetailsCtaButtonLink
                variant="secondary"
                to={
                    permissions?.projects?.read
                        ? generatePath(routes.PROJECT_DETAILS_ROUTE.handle.path, {id: project.id})
                        : ''
                }
                $isReadOnly={!permissions?.projects?.read}
            >
                <Flexbox render="span" align="center" gap={2}>
                    <File02Icon size={15} />
                    <b>{t('projects:pri_n', {code: project.code})}</b>
                    {project.status && (
                        <>
                            <SquareIcon className="custom" size={8} color={projectStatusToColor[project.status]} />
                            {t(projectStatusToLabel[project.status])}
                        </>
                    )}
                </Flexbox>
            </StyledPatientDetailsCtaButtonLink>
        )
    }

    return null
}
